<!-- その他ページ -->
<template>
  <div>
    <CrpgTemplatesOtherPage />
  </div>
</template>

<script>
import CrpgTemplatesOtherPage from "@/components/templates/OtherPage.vue";

export default {
  name: "CrthOtherPage",
  components: {
    CrpgTemplatesOtherPage
  }
};
</script>

<style lang="scss" scoped></style>
